var _excluded = ["id", "name", "items", "selectedItem", "toValue", "toLabel", "onChange", "disabled", "onFocus", "onBlur"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from "react";
import { useFocusWithin } from "../hooks";
import Segment from "./Segment";
import SegmentedControlContainer from "./SegmentedControlContainer";
import { jsx as ___EmotionJSX } from "@emotion/core";

function idAsValue(item) {
  return item ? item.id : null;
}

function displayAsLabel(item) {
  return item ? item.display : "";
}

export default function SegmentedControl(props) {
  var id = props.id,
      name = props.name,
      items = props.items,
      selectedItem = props.selectedItem,
      toValue = props.toValue,
      toLabel = props.toLabel,
      onChange = props.onChange,
      disabled = props.disabled,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      containerProps = _objectWithoutPropertiesLoose(props, _excluded);

  var _useFocusWithin = useFocusWithin({
    onFocus: onFocus,
    onBlur: onBlur
  }),
      focusRef = _useFocusWithin[0],
      focused = _useFocusWithin[1];

  return ___EmotionJSX(SegmentedControlContainer, _extends({
    ref: focusRef,
    role: "radiogroup"
  }, containerProps), items.map(function (item, index) {
    return ___EmotionJSX(Segment, {
      key: toValue(item) || undefined,
      id: id || name,
      name: name,
      index: index,
      item: item,
      selectedItem: selectedItem,
      toValue: toValue,
      toLabel: toLabel,
      onChange: onChange,
      focused: focused,
      disabled: disabled
    });
  }));
}
SegmentedControl.defaultProps = {
  toLabel: displayAsLabel,
  toValue: idAsValue,
  disabled: false
};